import { Injectable } from '@angular/core';
import { DialogService, DialogRef, DialogResult } from '@progress/kendo-angular-dialog';
import { Observable, Subject } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { ConfirmationDialogInputComponent } from '../components';


@Injectable({
  providedIn: 'root'
})

export class ConfirmationDialogInputService {

  constructor(protected dialogService: DialogService) { }


  open(title: string, content: string): Observable<object> {
    const resultSubject = new Subject<object>();

    const dialogRef = this.dialogService.open({
      content: ConfirmationDialogInputComponent
      , title: title
      , cssClass: 'isg-dialog-editor'
      , preventAction: (ev: any, dialog) => {
        if (ev && ev.value) { // Prevent only for "Ok" or "Yes" actions
          const formGroup = (dialog?.content.instance as ConfirmationDialogInputComponent).formGroup;
          if (!formGroup.valid) {
            formGroup.get("content")?.markAsTouched();
          }
          return !formGroup.valid;
        }
        return false; // Allow other actions
      }
    });

    const confirmationInfo = dialogRef.content.instance as ConfirmationDialogInputComponent;
    confirmationInfo.title = title;
    confirmationInfo.content = content;

    confirmationInfo.valueEntered.pipe(take(1)).subscribe((result: any) => {
      dialogRef.close();
      resultSubject.next(result);
      resultSubject.complete();
    });

    return resultSubject.asObservable();
  }
}
